import { render, staticRenderFns } from "./anli.vue?vue&type=template&id=74ba52a4&scoped=true&"
import script from "./anli.vue?vue&type=script&lang=js&"
export * from "./anli.vue?vue&type=script&lang=js&"
import style0 from "./anli.vue?vue&type=style&index=0&id=74ba52a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ba52a4",
  null
  
)

export default component.exports